import { DateTime } from 'luxon';

const ctrl = []

ctrl.formatDate = (isoString) => {
  const fecha = DateTime.fromISO(isoString).setLocale('es');
  return fecha.toFormat('dd/MM/yyyy');
};

ctrl.formatDateTime = (isoString) => {
  const fecha = DateTime.fromISO(isoString).setLocale('es');
  return fecha.toFormat('dd/MM/yyyy HH:mm');
};

export default ctrl;